<template>

  <div class="downloads">

    <h2>Auto-Downloaded KRA Files</h2>


    <!-- Disk usage -->

    <div v-if="diskInfo" class="disk-usage">

      <p><strong>Disk Usage:</strong> {{ diskInfo.used }} used of {{ diskInfo.total }} ({{ diskInfo.percent_used }}%)</p>

    </div>


    <!-- Folder filter buttons -->

    <div v-if="folderList.length">

      <button

        v-for="folder in folderList"

        :key="folder"

        @click="selectedFolder = folder"

        :class="{ active: selectedFolder === folder }"

      >

        {{ folder }}

      </button>

    </div>


    <!-- File groups by type -->

    <div v-if="selectedFolder && fileTree[selectedFolder]">

      <h3>{{ selectedFolder }}</h3>


      <div v-if="filteredFiles('S').length">

        <h4>S Races</h4>

        <ul>

          <li v-for="file in filteredFiles('S')" :key="file">

            <a :href="fileUrl(selectedFolder, file)" target="_blank">{{ file }}</a>

          </li>

        </ul>

      </div>


      <div v-if="filteredFiles('J').length">

        <h4>J Races</h4>

        <ul>

          <li v-for="file in filteredFiles('J')" :key="file">

            <a :href="fileUrl(selectedFolder, file)" target="_blank">{{ file }}</a>

          </li>

        </ul>

      </div>


      <div v-if="filteredFiles('Y').length">

        <h4>Y Races</h4>

        <ul>

          <li v-for="file in filteredFiles('Y')" :key="file">

            <a :href="fileUrl(selectedFolder, file)" target="_blank">{{ file }}</a>

          </li>

        </ul>

      </div>


      <div v-if="filteredFiles('B').length">

        <h4>B Races</h4>

        <ul>

          <li v-for="file in filteredFiles('B')" :key="file">

            <a :href="fileUrl(selectedFolder, file)" target="_blank">{{ file }}</a>

          </li>

        </ul>

      </div>

    </div>


    <p v-else>Loading folders or none found...</p>

  </div>

</template>


<script>

import axios from 'axios'


export default {

  name: 'Downloads',

  data() {

    return {

      fileTree: {},

      selectedFolder: '',

      folderList: [],

      diskInfo: null

    }

  },

  methods: {

    async fetchFiles() {

      try {

        const res = await axios.get('https://api.gamedatarun.com/api/downloads/grouped-downloads/')

        this.fileTree = res.data

        this.folderList = Object.keys(res.data).sort().reverse()

        this.selectedFolder = this.folderList[0] || ''

      } catch (e) {

        console.error("Failed to load folders", e)

      }

    },

    async fetchDiskInfo() {

      try {

        const res = await axios.get('https://api.gamedatarun.com/api/downloads/disk-info/')

        this.diskInfo = res.data

      } catch (e) {

        console.error("Failed to load disk info", e)

      }

    },

    fileUrl(folder, file) {

      return `https://api.gamedatarun.com/downloads/${folder}/${file}`

    },

    filteredFiles(prefix) {

      if (!this.selectedFolder || !this.fileTree[this.selectedFolder]) return []

      return this.fileTree[this.selectedFolder].filter(file =>

        file.startsWith(prefix)

      )

    }

  },

  mounted() {

    this.fetchFiles()

    this.fetchDiskInfo()

  }

}

</script>


<style scoped>

.downloads {

  padding: 20px;

}

.downloads h2 {

  font-size: 1.5rem;

  margin-bottom: 10px;

}

.downloads h3 {

  margin-top: 20px;

  color: #fff;

}

.downloads h4 {

  margin-top: 15px;

  color: #fff;

  font-size: 1.2rem;

}

.downloads ul {

  list-style: none;

  padding: 0;

}

.downloads li {

  margin-bottom: 6px;

}

.downloads button {

  margin-right: 8px;

  margin-bottom: 10px;

  padding: 6px 12px;

  background-color: #007bff;

  border: none;

  color: white;

  border-radius: 4px;

  cursor: pointer;

}

.downloads button.active {

  background-color: #0056b3;

}

.disk-usage {

  margin-bottom: 15px;

  font-weight: bold;

  color: #fff;

}

</style>

